import { PortalContextService } from '@/core/services/portal-context.service';
import { AnfrageNavigationFormComponent, MoveDirection } from '@/core/components/anfrage-navigation-form/anfrage-navigation-form.component';
import { Component } from '@angular/core';
import { FormGroup, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumenttypeDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/documenttype-display-model';
import { ContactDataDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';
import { DocumentDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/document-display-model';
import { SectionService } from '@/core/services/section.service';
import { GlobalEnumsAceRechtsform } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-rechtsform';

@Component({
  selector: 'attachments-process-step',
  templateUrl: './attachments-process-step.component.html',
  styleUrls: ['./attachments-process-step.component.scss']
})
export class AttachmentsProcessStepComponent extends AnfrageNavigationFormComponent {
  public attachmentProcessStepForm: UntypedFormGroup = new UntypedFormGroup({
    attachments: new UntypedFormControl(null, []),
  });

  public get formGroup(): FormGroup<any> {
    return this.attachmentProcessStepForm;
  }

  public contactData: ContactDataDisplayModel;
  public attachments: DocumentDisplayModel[];
  public documentTypes: DocumenttypeDisplayModel[];

  public get AnfrageId(): string {
    return this.anfrage.id;
  }

  public get rechtsform(): GlobalEnumsAceRechtsform | null {
    return this.contactData?.institution?.rechtsform != null ? this.contactData.institution.rechtsform : null;
  }

  public get attachmentsFormControl(): UntypedFormControl {
    return <UntypedFormControl>this.attachmentProcessStepForm.controls["attachments"];
  }

  constructor(protected sectionService: SectionService, protected route: ActivatedRoute, protected router: Router, protected portalContextService: PortalContextService) {
    super(sectionService, router, route, portalContextService);

    this.contactData = this.route.snapshot.data.contactData;
    this.documentTypes = this.route.snapshot.data.documenttypes;
    this.attachments = this.route.snapshot.data.attachments;

    this.attachmentsFormControl.patchValue(this.attachments);

    this.router.events.subscribe(() => {
      this.documentTypes = this.route.snapshot.data.documenttypes;
      this.attachments = this.route.snapshot.data.attachments;
      this.attachmentsFormControl.patchValue(this.attachments);
    })
  }

  protected save(shouldSave: boolean, moveDirection: MoveDirection): void {
    // Nothing to save on that form 
    this.move(moveDirection);
  }
}
